// import { hideSilentSpeakersSelector, makeSpeakersSelector, useHudStore } from "@/domains/hud/store";
import HudSpeakerList from "@/domains/hud/components/HudSpeakersList";

export default function HudSpeakerListContainer() {
  // const hideSilentSpeakers = useHudStore(hideSilentSpeakersSelector);
  // const list = useHudStore(makeSpeakersSelector);

  // console.log({ hideSilentSpeakers, list });

  return <HudSpeakerList speakers={[]} />;
}
